const DESKTOP = window.matchMedia('(min-width: 750px)');
const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

function posterOnly() {
  const connection = navigator.connection;
  if (REDUCED.matches) return true;
  if (connection && connection.saveData) return true;
  return ['slow-2g', '2g', '3g'].includes((connection && connection.effectiveType) || '');
}

function afterLoad(callback) {
  if (document.readyState === 'complete') callback();
  else window.addEventListener('load', callback, { once: true });
}

class VideoSource extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;
    this.loaded = false;
    this.userPaused = false;
    this.background = this.dataset.mode === 'background';
    const toggle = this.querySelector('.video-source__toggle');
    if (toggle) toggle.addEventListener('click', () => this.toggle());
    const play = this.querySelector('.video-source__play');
    if (play) play.addEventListener('click', () => this.playContent());
    if (this.background && posterOnly()) return;
    afterLoad(() => {
      this.observer = new IntersectionObserver((entries) => this.onIntersect(entries), { rootMargin: '200px 0px' });
      this.observer.observe(this);
    });
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  onIntersect(entries) {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        if (!this.loaded) this.load();
        if (this.background && !this.userPaused) this.video.play().catch(() => undefined);
      } else if (!this.video.paused) {
        this.video.pause();
      }
    }
  }

  load() {
    const src = DESKTOP.matches ? this.video.dataset.srcDesktop : this.video.dataset.srcMobile;
    if (!src) return;
    this.video.src = src;
    this.loaded = true;
    this.video.addEventListener('playing', () => this.classList.add('is-playing'), { once: true });
  }

  playContent() {
    if (!this.loaded) this.load();
    this.video.play().catch(() => undefined);
  }

  toggle() {
    const button = this.querySelector('.video-source__toggle');
    if (!button) return;
    if (this.video.paused) {
      this.userPaused = false;
      if (!this.loaded) this.load();
      this.video.play().catch(() => undefined);
      button.setAttribute('aria-pressed', 'false');
    } else {
      this.userPaused = true;
      this.video.pause();
      button.setAttribute('aria-pressed', 'true');
    }
  }
}

if (!customElements.get('video-source')) customElements.define('video-source', VideoSource);
